var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#696D6F;stroke-width:0.02;stroke-miterlimit:10;}\n\t.st1{fill:#696D6F;}\n\t.st2{fill:#696D6F;}\n\t.st3{fill:#696D6F;}\n\t.st4{fill:#696D6F;}\n\t.st5{fill:#696D6F;}\n\t.st6{fill:#696D6F;}\n\t.st7{fill:none;stroke:#696D6F;stroke-width:0.1;stroke-miterlimit:10;}\n\t.st8{fill:#696D6F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.000061,5.9869385v20h28v-20H2.000061z M28.000061,23.9869385h-24v-16h24V23.9869385z M26.000061,21.9869385 h-20l5-6l3,4l6-6L26.000061,21.9869385z M12.000061,11.9869385c0-1.1046143,0.8953857-2,2-2c1.1044922,0,2,0.8953857,2,2 c0,1.1044922-0.8955078,2-2,2C12.8954468,13.9869385,12.000061,13.0914307,12.000061,11.9869385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.0b0c7573bfebf4e765eee0d81ce603b3.svg";
export { ForwardRef as ReactComponent };